var _linearGradient, _linearGradient2, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlutter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 1999 2474.2",
    viewBox: "0 0 1999 2474.2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientTransform: "matrix(380.4042 -380.4175 -53.104 -53.1021 908228.3125 -700059.5)",
    gradientUnits: "userSpaceOnUse",
    x1: -2115.0029,
    x2: -2115.0029,
    y1: 1930.7407,
    y2: 1929.7407
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#616161",
    stopOpacity: 0.01
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientTransform: "matrix(565.291 0 0 -380.9571 1196694.25 743476.5625)",
    gradientUnits: "userSpaceOnUse",
    x1: -2115.2688,
    x2: -2114.2688,
    y1: 1946.3563,
    y2: 1946.3563
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#616161",
    stopOpacity: 0.01
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m381 1618-381-381 1237.1-1237h761.9m0 1141.5h-761.9l-285.4 285.4 381 381",
    fill: "#42a5f5",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m951.7 2188.8 285.4 285.4h761.9l-666.3-666.3",
    fill: "#0d47a1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m571.6 1808.1 380.4-380.5 380.4 380.4-380.4 380.5z",
    fill: "#42a5f5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m952 2188.5 380.4-380.4 53.1 53.1-380.4 380.4z",
    fill: "url(#a)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m951.7 2188.8 565.3-195.3-184.3-185.7",
    fill: "url(#b)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutter);
export default __webpack_public_path__ + "static/media/flutter.9a496ae25b064ea252617eecbce6d6b7.svg";
export { ForwardRef as ReactComponent };